import { createSelector } from 'reselect'

import { selectFinancialCockpitState } from './selectFinancialCockpitState'

export const selectCockpitFilter = createSelector(
  [selectFinancialCockpitState],
  ({ filter }) => filter
)
